import request from '@/utils/request'

const chechangParkingFee = {
  list(query) {
    return request({
      url: '/chechang/parking-fee/list',
      method: 'get',
      params: query
    })
  },
  detail(query) {
    return request({
      url: '/chechang/parking-fee/detail',
      method: 'get',
      params: query
    })
  },
  sync(data) {
    return request({
      url: '/chechang/parking-fee/sync',
      method: 'post',
      data
    })
  },
  syncProgress(query) {
    return request({
      url: '/chechang/parking-fee/sync/progress',
      method: 'get',
      params: query
    })
  },
  syncHistory(query) {
    return request({
      url: '/chechang/parking-fee/sync/history',
      method: 'get',
      params: query
    })
  },
  export(data) {
    return request({
      url: '/chechang/parking-fee/export',
      method: 'post',
      data
    })
  },
  bills(query) {
    return request({
      url: '/chechang/parking-fee/bills',
      method: 'get',
      params: query
    })
  },
  syncOne(data) {
    return request({
      url: '/chechang/parking-fee/sync-one',
      method: 'post',
      data,
      timeout: 300000
    })
  }
}

export default chechangParkingFee
